import Backbone from 'backbone';

import { SuspendedModel } from './SuspendedModel';

export const SuspendedCollection = Backbone.Collection.extend({

	model: SuspendedModel,
	
	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
	},

});